import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  ViewChild,
  ElementRef
} from '@angular/core';
import { ExperiencesService } from '../../experiences.service';
import { SharedService } from 'src/app/shared/shared.service';

@Component({
  selector: 'app-experience-calendar-filter',
  templateUrl: './experience-calendar-filter.component.html',
  styleUrls: ['./experience-calendar-filter.component.css']
})
export class ExperienceCalendarFilterComponent {
  @Input() countryIds;
  @Output() return = new EventEmitter();
  @ViewChild('closeAddExpenseModal', { static: true })
  closeAddExpenseModal: ElementRef;
  filterCal: any;
  countryRelatedCities = [];
  experienceTypes = [];
  countriesWithCities = [];
  country: any;
  city: any;
  type: any;
  constructor(private experienceApi: ExperiencesService,private sharedApi:SharedService) {
    this.experienceApi.getAllExperienceTypes().subscribe(Response => {
      // console.log(Response)
      this.experienceTypes = Response.data.experienceTypes;
    });
    this.sharedApi.getAllCountries().subscribe(Response => {
      // console.log(Response)
      this.countriesWithCities = Response.data.countries;
    });
  }

  filterCalendar(event) {
    this.filterCal = event.target.value;
  }
  getCities(event) {
    // console.log(event)
    this.sharedApi.getAllCities(event.target.value).subscribe(Response => {
      // console.log(Response)
      this.countryRelatedCities = [];
      this.countryRelatedCities = Response.data.cities;
    });
  }
  applyCity(event) {
    this.city = event.target.value;
  }
  setCalendarFilter() {
    if (this.filterCal === 'city') {
      this.return.emit({
        filterCal: this.filterCal,
        city: this.city,
        country: this.country
      });
      this.closeAddExpenseModal.nativeElement.click();
    } else if (this.filterCal === 'type') {
      this.return.emit({ filterCal: this.filterCal, type: this.type });
      this.closeAddExpenseModal.nativeElement.click();
    }
  }
  applyType(event) {
    this.type = event.target.value;
  }
}
